export const FETCH_TOP_RATED = 'FETCH_TOP_RATED'
export const FETCH_TOP_RATED_REQUEST = 'FETCH_TOP_RATED_REQUEST'
export const FETCH_TOP_RATED_SUCCESS = 'FETCH_TOP_RATED_SUCCESS'